/*
 * In View
 * https://github.com/camwiegert/in-view
 *
 */
import inView from 'in-view';

inView('.has-scroll-animation').on('enter', (e) => {
	const animationClassName = e.dataset.animation;
	console.log(animationClassName);
	setTimeout(() => {
		e.classList.add('animate__animated');
		e.classList.add(animationClassName);
	}, 300);
});

/*
 * Image Lightbox
 * https://github.com/yue1123/img-previewer
 *
 */
import GLightbox from 'glightbox';
const lightbox = GLightbox({
	selector: '.has-lightbox a',
});

import './blocks/accordion/frontend.js';
